import { Link } from 'react-router-dom'
import { ChevronRight, Ticket } from 'lucide-react'
import { useQuinielaCurrent } from '@/hooks/useQuiniela'
import { formatKickoff } from '@/lib/utils'

/** Acceso a La Quiniela desde Inicio. Solo aparece cuando hay una jornada oficial disponible. */
export function QuinielaHomeCard() {
  const { data } = useQuinielaCurrent(true)
  if (!data?.available || !data.jornada) return null
  const { jornada, snapshot } = data
  return (
    <Link to="/quiniela" className="card-premium-glow flex items-center gap-3 active-scale">
      <span className="h-10 w-10 rounded-xl bg-brand-soft/60 border border-brand/30 flex items-center justify-center shrink-0">
        <Ticket className="h-5 w-5 text-brand" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] font-bold uppercase tracking-[0.14em] text-brand">La Quiniela</span>
        <span className="block text-sm font-bold text-text truncate">Jornada {jornada.number}</span>
        <span className="block text-[11px] text-text-muted truncate">
          {snapshot ? `Analizada ${formatKickoff(snapshot.generated_at)}` : 'JA está analizando los 15 partidos'}
        </span>
      </span>
      <ChevronRight className="h-4 w-4 text-text-dim shrink-0" />
    </Link>
  )
}
